export default "__VITE_ASSET__DLYMaf4u__"